module.exports = __webpack_public_path__ + "img/logo_blue.fc74d5a0.png";